const smoothScroll = () => {
  const elms = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

  for (const elm of elms) {
    const href = elm.getAttribute('href');

    if (href === '#') {
      // #のみ
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        scroll({ top: 0, behavior: 'smooth' });
      });
    } else {
      // id指定
      const target = document.querySelector(href);

      if (target) {
        elm.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
          });
        });

      }
    }
  }
};

smoothScroll();